export const kgToPd = (value: number) => {
  return Math.round(value * 2.205);
};

export const pdToKg = (value: number) => {
  return Math.round(value * 0.45359237);
};

export const pdToPdAndOz = (value: number) => {
  const oz = value * 16;
  return { value1: Math.floor(oz / 16), value2: Math.round(oz % 16) };
};

export const PdAndOzToPd = (value1: number, value2: number) => {
  return value1 + value2 * 0.0625;
};

export const cmToIn = (value: number) => {
  return Math.round(value * 0.3937);
};

export const inToCm = (value: number) => {
  return Math.round(value * 2.54);
};

export const inToFtAndIn = (value: number) => {
  return { value1: Math.floor(value / 12), value2: Math.round(value % 12) };
};

export const ftAndInToIn = (value1: number, value2: number) => {
  return Math.round(value1 * 12 + value2);
};

const splitNum = (n: number) => {
  return [Math.trunc(n), n % 1];
};

const RoundP = (input: number, roundOn: number, places: number) => {
  const pow = Math.pow(10, places);
  const digit = pow * input;
  const [, div] = splitNum(digit);
  if (div >= roundOn) {
    return Math.ceil(digit) / pow;
  }
  return Math.floor(digit) / pow;
};

export const Round = (value: number) => {
  return RoundP(value, 0.5, 0);
};
